import {Injectable} from '@angular/core';
import {
  faBell,
  faPlus,
  faEye,
  faEdit,
  faFileExcel,
  faChartLine,
  faClock,
  faArchive,
  faBolt,
  faBomb,
  faWrench,
  faExclamationTriangle,
  faShoppingCart,
  faKey,
  faSmile,
  faSadTear,
  faSpinner,
  faDownload,
  faFrown,
  faTrashAlt,
  faNotesMedical,
  faGraduationCap,
  faGlobe,
  faMap,
  faCheck,
  faTimes,
  faPlusCircle,
  faCheckCircle,
  faUpload,
  faChevronUp,
  faChevronDown,
  faExchangeAlt,
  faMapMarkedAlt,
  faList,
  faTruck,
  faBars,
  faHome, faImage, faVideo, faFolderOpen, faUser, faSignOutAlt, faCopyright
} from '@fortawesome/free-solid-svg-icons';


@Injectable({
  providedIn: 'root'
})
export class IconService {

  faBell = faBell;
  faPlus = faPlus;
  faChartLine = faChartLine;
  faEye = faEye;
  faEdit = faEdit;
  faClock = faClock;
  faArchive = faArchive;
  faFileExcel = faFileExcel;
  faBolt = faBolt;
  faBomb = faBomb;
  faWrench = faWrench;
  faExclamationTriangle = faExclamationTriangle;
  faShoppingCart = faShoppingCart;
  faKey = faKey;
  faSmile = faSmile;
  faSadTear = faSadTear;
  faSpinner = faSpinner;
  faDownload = faDownload;
  faFrown = faFrown;
  faTrashAlt = faTrashAlt;
  faNotesMedical = faNotesMedical;
  faGraduationCap = faGraduationCap;
  faGlobe = faGlobe;
  faMap = faMap;
  faCheck = faCheck;
  faTimes = faTimes;
  faPlusCircle = faPlusCircle;
  faCheckCircle = faCheckCircle;
  faUpload = faUpload;
  faChevronUp = faChevronUp;
  faChevronDown = faChevronDown;
  faExchangeAlt = faExchangeAlt;
  faMapMarkedAlt = faMapMarkedAlt;
  faList = faList;
  faTruck = faTruck;
  faBars = faBars;
  faHome = faHome;
  faImage = faImage;
  faVideo = faVideo;
  faFolderOpen = faFolderOpen;
  faUser = faUser;
  faSignOutAlt = faSignOutAlt;
  faCopyright = faCopyright;

  constructor() {
  }
}
